import React from 'react'

import { Box, Title, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { ContactFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

import BankTransferOption from './Options/BankTransfer'
import IWillDecideLater from './Options/IWillDecideLater'
import ManualPaymentOption from './Options/ManualPayment'
import VirtualCardOption from './Options/VirtualCard'

interface Props {
  vendor: ContactFragment | undefined
  canCreateSingleUseCards: boolean
  canManageVendors: boolean
  hasCardsFeature: boolean
}

const PaymentMethodStep: React.FC<WizardStepRenderParams<WizardData> & Props> = ({
  data,
  onDataChanged,
  vendor,
  canCreateSingleUseCards,
  canManageVendors,
  hasCardsFeature: cardsEnabled,
}) => {
  const { employee } = useCurrentSession()

  return (
    <Box gap="s24">
      <Title
        description={i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.payment_method.description'
        )}
        title={i18n.t('procurement.purchase_orders.update_order_wizard.steps.payment_method.title')}
      />
      <Box gap="s24" paddingRight="s24">
        {employee && cardsEnabled && (
          <VirtualCardOption
            data={data}
            onDataChanged={onDataChanged}
            preferred={vendor?.preferredPaymentMethod === 'card'}
            selected={data.preferredPaymentMethod === 'virtualcard'}
            canCreateSingleUseCards={canCreateSingleUseCards}
          />
        )}
        <BankTransferOption
          data={data}
          onDataChanged={onDataChanged}
          preferred={vendor?.preferredPaymentMethod === 'banktransfer'}
          selected={data.preferredPaymentMethod === 'banktransfer'}
          vendor={vendor ?? undefined}
          canManageVendors={canManageVendors}
        />
        <ManualPaymentOption
          data={data}
          onDataChanged={onDataChanged}
          selected={data.preferredPaymentMethod === 'cash'}
        />
        <IWillDecideLater
          data={data}
          onDataChanged={onDataChanged}
          selected={data.preferredPaymentMethod === undefined}
        />
      </Box>
    </Box>
  )
}

export default PaymentMethodStep
